var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "main-content flex flex-col flex-grow p-4" },
    [
      _c("top-filter-item", {
        attrs: {
          schedulerView: _vm.schedulerView,
          isAdmin: _vm.isAdmin,
          currentUser: _vm.currentUser,
          company: _vm.company,
          placeHolderText: _vm.placeHolderText,
        },
        on: {
          optionChange: _vm.handleOptionChange,
          toggleAdditionalFilters: _vm.toggleAdditionalFilters,
        },
      }),
      _vm.showManagers && _vm.isAdmin
        ? _c("manager-scheduler", {
            attrs: {
              axisStart: _vm.dateRange.startDate,
              axisEnd: _vm.dateRange.endDate,
              managers: _vm.managers,
              currentUser: _vm.currentUser,
              selectedManagersIds: _vm.selectedManagersIds,
              company: _vm.company,
              companyId: _vm.company.id,
              shouldClearFilters: _vm.shouldClearFilters,
              showAdditionalFilters: _vm.showAdditionalFilters,
            },
            on: { close: _vm.toggleAdditionalFilters },
          })
        : _vm._e(),
      _vm.showContractors
        ? _c("contractor-scheduler", {
            attrs: {
              axisStart: _vm.dateRange.startDate,
              axisEnd: _vm.dateRange.endDate,
              currentUser: _vm.currentUser,
              companyId: _vm.company.id,
              company: _vm.company,
              shouldClearFilters: _vm.shouldClearFilters,
              selectedContractorsIds: _vm.selectedContractorsIds,
              showAdditionalFilters: _vm.showAdditionalFilters,
            },
            on: { close: _vm.toggleAdditionalFilters },
          })
        : _vm._e(),
      _vm.showProjects
        ? _c("projects-scheduler", {
            staticClass: "mb-10",
            attrs: {
              axisStart: _vm.dateRange.startDate,
              axisEnd: _vm.dateRange.endDate,
              currentUser: _vm.currentUser,
              shouldClearFilters: _vm.shouldClearFilters,
              showAdditionalFilters: _vm.showAdditionalFilters,
              selectedProjectsIds: _vm.selectedProjectsIds,
              companyId: _vm.company.id,
            },
            on: {
              filtersReset: _vm.handleProjectFiltersReset,
              close: _vm.toggleAdditionalFilters,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }